import * as React from 'react'
import { useCallback } from 'react'
import { Formik } from 'formik'

import { IUpdateContactFormModel, validate } from './typings'
import { useData, useHandlers } from './hooks'
import { ENTITY_TYPES } from '@sales-center/common'
import { UpdateContactFormFields } from './UpdateContactFormFields'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { useLocalisedValidations } from '@user/utils/useLocalisedValidations'

interface Props {
  contactId?: number
  entityId: number
  entityType: ENTITY_TYPES
  isPrimaryContact?: boolean
  onClose: () => void
}

export function UpdateContactFormWrapper(props: Props) {
  const { contactId, entityId, entityType, onClose } = props
  const { validatePostalCode } = useLocalisedValidations()
  const { status, contact, initialValues } = useData({ contactId })

  const { onSubmit } = useHandlers({
    onClose,
    entityId,
    contactId,
    entityType,
  })

  const validateForm = useCallback(
    (model: IUpdateContactFormModel) => {
      return validate(model, validatePostalCode)
    },
    [validatePostalCode],
  )

  return (
    <>
      {status === 'pending' && (
        <Box display="flex" justifyContent="center" p={2}>
          <CircularProgress />
        </Box>
      )}

      {status === 'success' && (
        <Formik
          onSubmit={onSubmit}
          validate={validateForm}
          initialValues={initialValues}
        >
          <UpdateContactFormFields
            {...props}
            entityId={entityId}
            entityType={entityType}
            contact={contact}
            onCancel={onClose}
          />
        </Formik>
      )}
    </>
  )
}
